import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getMembers } from "@/api/members";

export function useMemberDirectory(churchId: string | null | undefined) {
  const [search, setSearch] = useState("");
  const [request, setRequest] = useState({ search: "", page: 1 });

  useEffect(() => {
    const term = search.trim();
    if (term.length < 2) return;
    const timer = window.setTimeout(() => {
      setRequest({ search: term, page: 1 });
    }, 300);
    return () => window.clearTimeout(timer);
  }, [search]);

  const query = useQuery({
    queryKey: ["members", churchId, request.search, request.page],
    enabled: !!churchId,
    queryFn: () => getMembers(churchId!, request.page, 25, request.search),
  });

  return {
    ...query,
    search,
    activeSearch: request.search,
    onSearchChange(value: string) {
      setSearch(value);
      // Clear immediately, including any previously settled search. The effect
      // cleanup cancels pending work; query keys isolate late responses.
      if (value.trim().length < 2) setRequest({ search: "", page: 1 });
    },
    onPrevious: () => setRequest(current => ({ ...current, page: Math.max(1, current.page - 1) })),
    onNext: () => setRequest(current => ({ ...current, page: current.page + 1 })),
  };
}
